import { editUserDetails, getUserByToken } from '@/services/userService';

export const saveLanguagePreference = async ({
  tenantData,
  accessToken,
  NEXT_PUBLIC_CW_AUTH_URL,
  locale,
}: {
  tenantData: any;
  accessToken: string;
  NEXT_PUBLIC_CW_AUTH_URL: string;
  locale: string;
}) => {
  try {
    const user = await getUserByToken(
      tenantData?._id,
      tenantData?.tenantName,
      accessToken,
      NEXT_PUBLIC_CW_AUTH_URL
    );

    const userId = user?.id;

    const newAccessToken = accessToken;

    if (userId && newAccessToken && tenantData?._id) {
      const updateValues = {
        language_preference: locale,
      };

      console.log('Updating language preference for user:', userId);

      const response = await editUserDetails(
        userId,
        updateValues,
        tenantData._id,
        tenantData.tenantName,
        newAccessToken
      );

      if (response?.status === 201) {
        console.log('Language preference saved successfully:', locale);
      } else {
        console.warn(
          'Language preference update did not return success status:',
          response
        );
      }
    } else {
      console.warn(
        'Could not update language preference - missing required data:',
        {
          userId,
          hasAccessToken: !!newAccessToken,
          hasTenantId: !!tenantData?._id,
        }
      );
    }
  } catch (error) {
    console.error('Failed to save language preference:', error);
  }
};
